import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyDeviceRequests = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyDeviceRequests);
};
